import React, {Fragment, useEffect, useState} from "react";
import {useFormikContext} from 'formik';
import {useCoursesContext} from './../layout/courses/CourseProvider';
import {fetchYardDetails, saveYardDetails, updateYardDetails} from "../layout/courses/course.api.service";
import {toast, ToastContainer} from "react-toastify";
import {useRef} from "react";
import ENUMS from "../../utils/ENUMS";


const InputField = ({value, ...rest}) => {


    return (
        <input
            className="form__input-ex-sm"
            type="text"
            placeholder="0"
            name=""
            value={value || ""}
            required
            {...rest}
        />

    )

}

const HoleDetail = () => {
    const formik = useFormikContext();
    const {data, activeCourseIndex, clicking} = formik.values;
    const courseData = data[activeCourseIndex];
    const [holesPoint, setHolesPoint] = useState([]);
    const [newTees, setNewtees] = useState(false);

    const {onSubmit} = useCoursesContext();

    const yardsRef = useRef()

    const executeScroll = () => yardsRef.current.scrollIntoView({behavior: "smooth"});
useEffect(() => {
    const role = (localStorage.getItem("userRole") || "").toLowerCase();
    const isSuperAdmin = role === "superadmin";

    const fetchHoleData = async () => {
        try {
            let res;
            if (isSuperAdmin) {
    const token = localStorage.getItem(ENUMS.AUTH);
                const apiRes = await fetch(`https://timelygolf.co.uk/club/hole-detailsv2/?course_id=${courseData.id}`, {
                    method: "GET",
                   headers: {
            Authorization: `Bearer ${token}`
        }

                });
                res = await apiRes.json();
            } else {
                const apiRes = await fetchYardDetails(courseData.id);
                res = apiRes.data;
            }

            const holespointdata = res.data.holepoint;

            const new_holespointdata = holespointdata.map((hole) => {
                if (hole.tees.length === 0) {
                    setNewtees(true);
                    hole.tees = [
                        { yards: "", par: "", stroke_index: "", id: 2 },
                        { yards: "", par: "", stroke_index: "", id: 3 },
                        { yards: "", par: "", stroke_index: "", id: 4 }
                    ];
                } else {
                    setNewtees(false);
                }
                return hole;
            });

            setHolesPoint(new_holespointdata);
        } catch (e) {
            console.error("Failed to fetch yard details:", e);
            toast.error("Failed to fetch yard details");
        }
    };

    if (courseData?.id) {
        fetchHoleData();
    }
}, [courseData]);



    useEffect(() => {
        executeScroll();
    }, [activeCourseIndex, clicking]);


    // const handleYardsDetails = () => {
    //   // console.log(data[activeCourseIndex], "data");
    //   // console.log(yardDetails, "yard data");
    //   // console.log(holesPoint, "holes point");
    //   onSubmit(formik);
    // };

    const saveYardsAndPar = () => {
        console.log(newTees, "new Tees")

        if (newTees) {
            let yards_par_list = [];
            holesPoint.map((hole) => {
                hole.tees.map((tee) => {
                    const updated_tee = {
                        ...tee,
                        tees: tee.id,
                        holepoint: hole.id
                    }
                    yards_par_list.push(updated_tee);
                })
            })

            console.log(yards_par_list, "yards par");

            const yards_and_par = {
                yards_par_data: yards_par_list
            }

            console.log(yards_and_par, "yards and par");

            saveYardDetails(yards_and_par)
                .then(() => {

                    toast.success("Course data saved successfully");
                })
                .catch((err) => {
                    toast.error("Yards and Par Fields Empty");
                });
        } else {
            const yards_data = {
                holepoint: holesPoint
            }
            updateYardDetails(yards_data)
                .then(() => {

                    toast.success("Course data saved successfully");
                })
                .catch((err) => {
                    toast.error("Yards and Par Fields Empty");
                });
            ;

            console.log(yards_data, "yards par");
        }


    }
    console.log(holesPoint)

    const onChangeAllocated = (input, holeId, teeId, keyValue) => {
        if (input.target.value.match(/^[0-9, :]+$/) || input.target.value.length === 0) {
            const updatedHoles = holesPoint.map((hole) => {
                if (holeId == hole.id) {
                    console.log(hole.tees, "");
                    hole.tees.map((tee) => {
                        // console.log(tee, "tee");
                        if (tee.id === teeId) {
                            if (keyValue === "yards" && input.target.value.length < 5) {
                                tee[keyValue] = input.target.value;
                            }

                            if (keyValue === "par" && input.target.value.length < 2) {
                                tee[keyValue] = input.target.value;
                            }

                            if (keyValue === "stroke_index" && input.target.value.length < 3) {
                                tee[keyValue] = input.target.value;
                            }
                            return tee;
                        } else {
                            return tee;
                        }
                    });
                    // console.log(updatedList, "updated list");

                    return hole;
                } else {
                    return hole;
                }
            });

            // console.log(updatedHoles, "hole data");
            setHolesPoint(updatedHoles);
        }
    };


    // const applyToAll=(value,index)=>{
    //   const updatedHoles=holesPoint.map((hole)=>{
    //     // console.log(hole);
    //     hole.tees[index].yards=value.yards;
    //     hole.tees[index].par=value.par;
    //     hole.tees[index].stroke_index=value.stroke_index;
    //     console.log(value.yards)
    //     return hole
    //   })
    //   setHolesPoint(updatedHoles)
    // }

    return (
        <>
            <ToastContainer/>
            <div className="c-mapping__box yard_and_par">
                <h2 ref={yardsRef} className="c-mapping__box-txt text-jost-sb-24">
                    Yards and Par for {courseData?.course_name}
                </h2>
                <p className="c-mapping__box-para text-ops-rg-16">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porta,
                    felis vitae accumsan semper, urna velit consequat nibh.
                </p>
                <div className="hole">
                    <table className="hole__table">
                        <tr className="hole__table_head">
                            <th className="text-jost-sb-18"></th>
                            <th className="text-jost-sb-18">Forward/Red Tees</th>
                            <th className="text-jost-sb-18">Tee of the day/Yellow Tees</th>
                            <th className="text-jost-sb-18">Medal/White Tees</th>
                        </tr>
                        <tr className="hole__table_sub-head">
                            <td id="cell1-0"></td>
                            <td>
                                <tr>
                                    <span className="text-jost-sb-20">Yards</span>
                                    <span className="text-jost-sb-20">Par</span>
                                    <span className="text-jost-sb-20">Stroke Index</span>
                                </tr>
                            </td>
                            {" "}
                            <td>
                                <tr>
                                    <span className="text-jost-sb-20">Yards</span>
                                    <span className="text-jost-sb-20">Par</span>
                                    <span className="text-jost-sb-20">Stroke Index</span>
                                </tr>
                            </td>
                            {" "}
                            <td>
                                <tr>
                                    <span className="text-jost-sb-20">Yards</span>
                                    <span className="text-jost-sb-20">Par</span>
                                    <span className="text-jost-sb-20">Stroke Index</span>
                                </tr>
                            </td>
                        </tr>

                        {holesPoint ? holesPoint.map((hole, index) => (
                            <Fragment key={index.toString()}>
                                <tr id="row1" className="hole__table_content">
                                    <td id="cell1-0" className="text-jost-sb-18">Hole {hole.hole_index}</td>
                                    <td id="cell1-1" className="hole-data">
                                        <tr>
                                            <InputField
                                                value={hole.tees[2]?.yards} onChange={(i) => {
                                                onChangeAllocated(i, hole.id, hole.tees[2]?.id, "yards")
                                            }}/>
                                            <InputField
                                                value={hole.tees[2]?.par} onChange={(i) => {
                                                onChangeAllocated(i, hole.id, hole.tees[2]?.id, "par")
                                            }}/>
                                            <InputField
                                                value={hole.tees[2]?.stroke_index} onChange={(i) => {
                                                onChangeAllocated(i, hole.id, hole.tees[2]?.id, "stroke_index")
                                            }}/>
                                        </tr>
                                    </td>

                                    <td id="cell1-1" className="hole-data">
                                        <tr>
                                            <InputField
                                                value={hole.tees[1]?.yards} onChange={(i) => {
                                                onChangeAllocated(i, hole.id, hole.tees[1]?.id, "yards")
                                            }}/>
                                            <InputField
                                                value={hole.tees[1]?.par} onChange={(i) => {
                                                onChangeAllocated(i, hole.id, hole.tees[1]?.id, "par")
                                            }}/>
                                            <InputField
                                                value={hole.tees[1]?.stroke_index}
                                                onChange={(i) => {
                                                    onChangeAllocated(i, hole.id, hole.tees[1]?.id, "stroke_index")
                                                }}/>
                                        </tr>
                                    </td>


                                    <td id="cell1-1" className="hole-data">
                                        <tr>
                                            <InputField
                                                value={hole.tees[0]?.yards}
                                                onChange={(i) => {
                                                    onChangeAllocated(i, hole.id, hole.tees[0]?.id, "yards")
                                                }}
                                            />

                                            <InputField
                                                value={hole.tees[0]?.par}
                                                onChange={(i) => {
                                                    onChangeAllocated(i, hole.id, hole.tees[0]?.id, "par")
                                                }}
                                            />
                                            <InputField
                                                value={hole.tees[0]?.stroke_index}
                                                onChange={(i) => {
                                                    onChangeAllocated(i, hole.id, hole.tees[0]?.id, "stroke_index")
                                                }}
                                            />
                                        </tr>
                                    </td>

                                </tr>

                                {/*{index===0 &&*/}
                                {/*<tr id="row1" className="hole__table_content">*/}
                                {/*  <td id="cell1-0" className="text-jost-sb-18"></td>*/}
                                {/*<td id="cell1-1">     <a style={{cursor: "pointer"}} onClick={()=>applyToAll(hole.tees[0], 0)}  className="acccore__box__sec2-link">Apply To All</a></td>*/}
                                {/*<td id="cell1-1">     <a style={{cursor: "pointer"}} onClick={()=>applyToAll(hole.tees[1], 1)}  className="acccore__box__sec2-link">Apply To All</a></td>*/}
                                {/*<td id="cell1-1">     <a style={{cursor: "pointer",paddingLeft:"5rem"}} onClick={()=>applyToAll(hole.tees[2], 2)}  className="acccore__box__sec2-link">Apply To All</a></td>*/}


                                {/*</tr>}*/}
                            </Fragment>)
                        ) : null}

                        {/*<tr id="row1" className="hole__table_content">*/}
                        {/*    <td id="cell1-0" className="number-jost-sb-18">Hole 2</td>*/}
                        {/*    <td id="cell1-1">  <input className="form__input-sm" type="number" placeholder="" name="" required/></td>*/}
                        {/*    <td id="cell1-1">  <input className="form__input-sm" type="number" placeholder="" name="" required/></td>*/}
                        {/*    <td id="cell1-1">  <input className="form__input-sm" type="number" placeholder="" name="" required/></td>*/}

                        {/*</tr>*/}
                    </table>
                    <a
                        style={{marginTop: "3rem"}}
                        target="_self"
                        onClick={saveYardsAndPar}
                        target="_self"
                        className="res-btn-primary c-mapping__box-next"
                    >
                        Save Course
                    </a>
                </div>
            </div>
        </>
    );
};
export default HoleDetail;
